import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  UpdateButton,
} from "../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getUimodules,
  updateUimodule,
} from "../../redux/features/uimoduleSlice";

const EditUimodule = ({ rowData, dispatchdata }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.uimodule);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      module_name: rowData.module_name,
      module_id: rowData.module_id,
    },
    onSubmit: (values) => {
      dispatch(updateUimodule({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getUimodules(dispatchdata));
          formik.resetForm();
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Update Ui Module"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="module_name"
                    value={formik.values.module_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Module Name"
                  />
                  <TextField
                    name="module_id"
                    type="number"
                    value={formik.values.module_id}
                    disabled
                    fullWidth
                    label="Module ID"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditUimodule;
